import { baseService } from "cortex/ui/src/service/base";

export const networkDeviceVersionsService = {
  load(networkId: number) {
    return baseService.get(`/api/network/${networkId}/device_versions`);
  },
};

export default networkDeviceVersionsService;
